import React from "react";

export default function MySQL_NULLIF() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_NULLIF</h1>
      <p>This is the MySQL_NULLIF component generated from the SQL JSON.</p>
    </div>
  );
}
